import React, { useState, useRef, useEffect } from 'react';
//import P from 'prop-types';
import { useForm } from 'react-hook-form';
import { ResultadoBusca } from '../ResultadoBusca';
import { trackGAEvent, trackMetaPixelEvent } from '../../utils/tracking';
import './style.css';
//import { LabelForm } from '../LabelForm';
//import { InputText } from '../InputText';

export const Procura = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResultsCount, setSearchResultsCount] = useState(0);
  const debounceRef = useRef(null);
  const lastTrackedRef = useRef('');
  const { register, handleSubmit } = useForm();

  const trackSearch = (termo, count) => {
    trackMetaPixelEvent('Search', {
      search_string: termo,
      content_type: 'product',
      value: count,
    });

    trackGAEvent('Ecommerce', 'Search', termo, count);
  };

  const handleValidForm = (form) => {
    const termo = form.procura || '';
    setSearchTerm(termo);

    if (termo.length === 0) {
      setSearchResultsCount(0);
    }
  };

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    const termo = searchTerm.trim();
    if (termo.length < 2) return;

    debounceRef.current = setTimeout(() => {
      if (lastTrackedRef.current === termo) return;
      lastTrackedRef.current = termo;

      trackSearch(termo, searchResultsCount);
    }, 600);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchTerm, searchResultsCount]);

  return (
    <div style={{ margin: '10px 10px 0 10px' }}>
      <form
        //onSubmit={handleSubmit(handleValidForm)}
        onChange={handleSubmit(handleValidForm)}
        className="modal-content-dialog padTop20 buscaSticky"
        style={{ borderTop: 0, padding: 0 }}
      >
        <div className="form-group" style={{ marginBottom: '25px' }}>
          {/* <LabelForm text={'Digite o nome do produto'} /> */}
          <input
            type="text"
            placeholder={'ex. coca cola'}
            className="form-control"
            {...register('procura')}
            style={{ marginTop: 15 }}
          />
          <i className="material-icons" style={{ top: '19px' }}>
            search
          </i>
        </div>

        {/* <div className="form-container">
          <input
            type="text"
            placeholder="ex. coca cola"
            className="inputProcura {
"
            {...register('procura2')}
          />
        </div> */}
      </form>
      <ResultadoBusca searchTerm={searchTerm} onCountChange={(n) => setSearchResultsCount(n)} />
    </div>
  );
};

// Procura.propTypes = {
//   param: P.object,
// };
